"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFailedPaymentReasons = exports.EConfigurationKeys = void 0;
var EConfigurationKeys;
(function (EConfigurationKeys) {
    EConfigurationKeys["MAX_ALLOWED_PM_FAILURE"] = "max_allowed_pm_failure";
})(EConfigurationKeys = exports.EConfigurationKeys || (exports.EConfigurationKeys = {}));
var EFailedPaymentReasons;
(function (EFailedPaymentReasons) {
    EFailedPaymentReasons["CARD_BLOCKED"] = "card_blocked_by_bond";
    EFailedPaymentReasons["UNKNOWN"] = "unknown";
    EFailedPaymentReasons["GENERIC_DECLINE"] = "generic_decline";
    EFailedPaymentReasons["INSUFFICIENT_FUNDS"] = "insufficient_funds";
    EFailedPaymentReasons["LOST_CARD"] = "lost_card";
    EFailedPaymentReasons["STOLEN_CARD"] = "stolen_card";
    EFailedPaymentReasons["EXPIRED_CARD"] = "expired_card";
    EFailedPaymentReasons["INCORRECT_CVC"] = "incorrect_cvc";
    EFailedPaymentReasons["PROCESSING_ERROR"] = "processing_error";
    EFailedPaymentReasons["INCORRECT_NUMBER"] = "incorrect_number";
    EFailedPaymentReasons["CARD_VELOCITY_EXCEEDED"] = "card_velocity_exceeded";
    EFailedPaymentReasons["RESTRICTED_CARD"] = "restricted_card";
})(EFailedPaymentReasons = exports.EFailedPaymentReasons || (exports.EFailedPaymentReasons = {}));
//# sourceMappingURL=configuration.dto.js.map